import VueRouter from "vue-router";
import Home from "@/pages/Home";
import Offer from "@/pages/offer/Offer";
import EditOffer from "@/pages/offer/EditOffer";
import CurrentOffer from "@/pages/offer/CurrentOffer";
import SavedOffers from "@/pages/offer/SavedOffers";
import SearchHistory from "@/pages/search/SearchHistory";
import SearchPage from "@/pages/search/SearchPage";
import ManualImportPage from "@/pages/ManualImportPage";
import NotAuthenticated from "@/pages/NotAuthenticated";
import NotFound from "@/pages/NotFound";
import store from "@/store";
import loginStatus from "@/utils/login-status";
import Order from "@/pages/order/Order";
import EditOrder from "@/pages/order/EditOrder";
import SavedOrders from "@/pages/order/SavedOrders";

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
        },
        { path: '/offer/:id/view', component: Offer, name: 'offer' },
        { path: '/offer/:id/edit', component: EditOffer, name: 'edit-offer' },
        { path: '/current-offer', component: CurrentOffer, name: 'current-offer' },
        { path: '/saved-offers', component: SavedOffers, name: 'saved-offers' },

        { path: '/order/:id/view', component: Order, name: 'order' },
        { path: '/order/:id/edit', component: EditOrder, name: 'edit-order' },
        { path: '/saved-orders', component: SavedOrders, name: 'saved-orders' },

        { path: '/search-history', component: SearchHistory, name: 'search-history' },
        { path: '/search-page', component: SearchPage, name: 'search-page' },
        { path: '/manual-import', component: ManualImportPage, name: 'manual-import' },
        {
            path: '/not-authenticated',
            component: NotAuthenticated,
            meta: {
                guest: true,
            }
        },
        { path: '*', component: NotFound }
    ]
})

// https://www.digitalocean.com/community/tutorials/how-to-set-up-vue-js-authentication-and-route-handling-using-vue-router
router.beforeEach(async (to, from, next) => {
    let isLoggedIn;
    if(!store.state.appLoaded) {
        isLoggedIn = await loginStatus();
    } else {
        isLoggedIn = store.getters.isLoggedIn;
    }

    if (to.matched.some(record => record.meta.guest)) {
        // Only allow guests on this page
        if (!isLoggedIn) {
            next();
        } else {
            next('/');
        }
    } else {
        // We assume that all pages which aren't specifically marked as guest, require authentication
        if (isLoggedIn) {
            next();
        } else {
            next('/not-authenticated');
        }
    }
})

export default router;